/**
 * Query key factory for List Items
 * 
 * This file provides a consistent way to define query keys for React Query
 * to properly deduplicate and invalidate related queries.
 */

/**
 * Centralized query keys for list items to ensure consistent cache management
 */
export const listKeys = {
  // Base key for all list-related queries
  all: ['lists'] as const,
  
  // Key for lists of list items
  lists: () => [...listKeys.all, 'list'] as const,
  
  // Key for list items by topic ID
  byTopic: (topicId: string) => [...listKeys.lists(), { topicId }] as const,
  
  // Key for list items by user ID
  byUser: (userId: string) => [...listKeys.lists(), { userId }] as const,
  
  // Base key for list item detail queries
  details: () => [...listKeys.all, 'detail'] as const,
  
  // Key for a specific list item by ID
  detail: (id: string) => [...listKeys.details(), id] as const,
};